<template>
  <div>
    <div class="flex justify-between items-center">
      <h1 class="text-lg font-bold" v-if="this.exam">
        {{this.exam.title}}
      </h1>

      <button class="mob-btn mob-btn--red" @click="showFinishModal()">
        Finalizar
      </button>
      <MobBaseModal ref="mobFinishExamDiagModal" modal-id="modal-finish" title="Finalizar examen"
        body-text="Realmente deseas finalizar el examen?" :show-button1="true" :show-button2="true"
        button1-text="Aceptar" button2-text="Cancelar" :button1-callback="acceptFinishExamDiagModal"
        :button2-callback="cancelFinishExamDiagModal" />
    </div>

    <div class="border rounded-lg mt-4">
      <MobSteps class="border-b" :items="examSteps" :allowNavigation="true" @goBack="goBack" @goForward="goForward" />
      <div class="border-t p-7" v-if="examExercise">
        <ExerciseItem 
          ref="exerciseModule"
          :exercise="examExercise" 
          :noCheck="true" 
          :originId="this.examId" 
          :origin="'examDiag'"
          :allowCorrection="true" 
          @nextQuestion="nextQuestion" 
          :lastExercise="this.lastExercise"
          @goToResults="goToResults" />
      </div>
    </div>
  </div>
</template>

<script>
import { MobSteps } from "@/views/V2/components";
import mathJaxRender from "@/Utils/mathjax-render.js";
import ExerciseItem from "../components/ExerciseItem.vue";
import {getExercises, getExam} from "@/services/exams.service";
import {getQuestion} from "@/services/questions.service";
import { MobBaseModal } from "@/views/V2/components";

export default {
  name: "ExamDetail",
  components: {
    MobSteps,
    ExerciseItem,
    MobBaseModal
  },
  data() {
    return {
      examExerciseId: null,
      examExercise: {},
      examSteps: [],
      exam: {},
      examId: null,
      exercises: [],
      lastExercise: false,
    };
  },
  computed: {
    course() {
      return this.$store.state.course.current;
    },
  },
  methods: {
    goBack() {
      let indexQuestionActive =  this.exercises.findIndex(question => question.id === this.examExerciseId);

      if (indexQuestionActive === 0) {
        return;
      }
      this.nextQuestion(this.examExerciseId, false, true);
    },
    goToResults(){
      // /course/:id/diagnosticTest/:examId/results
      this.$router.push(`${this.examId}/results`);
    },
    goForward() {
      let indexQuestionActive =  this.exercises.findIndex(question => question.id === this.examExerciseId);

      if (indexQuestionActive > this.exercises.length - 1) {
        return;
      }
      this.nextQuestion(this.examExerciseId, true, false);
    },
    async nextQuestion(questionId, plus = true, goback = false) {
      let sum = plus ? 1 : goback? -1 : 0;
      let indexQuestionActive =  this.exercises.findIndex(question => question.id === questionId) + sum;
      this.lastExercise = false;
      if (indexQuestionActive > this.exercises.length - 1) {
         return;
      }
      if (indexQuestionActive > this.exercises.length - 2) {
        this.lastExercise = true;
      }
      this.examSteps = [];
      for (let exercisesKey in this.exercises) {
        let exercise = this.exercises[exercisesKey];
        if (exercisesKey == indexQuestionActive) {
          this.examSteps.push({state: "active"})
          this.examExerciseId = exercise.id;
        } else {
          this.examSteps.push({state: "pending"})
        }
      }
      if (this.examExerciseId) {
        this.examExercise = await getQuestion(this.examExerciseId);
        mathJaxRender();
      }
    },
    async fillExercises() {
      let loader = this.$loading.show({});
      this.exercises = await getExercises(this.examId);
      if ( this.exercises.length > 0) {
        this.examSteps = [];
        this.nextQuestion( this.exercises[0].id, false);

      }
      loader.hide();
    },
    showFinishModal() {
      this.$refs.mobFinishExamDiagModal.showModal();
    },
    acceptFinishExamDiagModal() {
      this.$refs.mobFinishExamDiagModal.closeModal();
      this.$refs.exerciseModule.finishQuestionnaire();
    },
    cancelFinishExamDiagModal() {
      this.$refs.mobFinishExamDiagModal.closeModal();
    },
  },
  async mounted() {
    this.examId = this.$route.params.examId;
    if (this.examId) {
      this.exam = await getExam(this.examId);
      await this.fillExercises();
    }
    mathJaxRender();
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  }
};
</script>
